import React from 'react'
import Head from 'next/head'

import Backend from '../../../../../utils/Backend'
import handleTimeout from '../../../../../helper/timeout_handler'
import renderVehicleTitle from '../../../../../helper/vehicle_title_render'

import VehicleOptions from '../../../../../components/VehicleOptions'


// baseVehicle get here from the special requests far below (NEXT.JS APPROACH)
export default function CommercialOptionsPage({ baseVehicle }: any) {
  return (
    <>
      <Head>
        <title>{renderVehicleTitle(baseVehicle)} | Nevo</title>
      </Head>

      <VehicleOptions baseVehicle={baseVehicle} commercial />
    </>
  );
};

export async function getServerSideProps({ res, params: { id } } : any) {
  // params contains the vehicle `id`
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  const response = await handleTimeout(Backend.getVehicleByID(id), `Vehicle ${id}`)

  if (!response) {
    throw new Error("Failed to fetch Vehicle")
  }

  const baseVehicle = response.data.content

  // Pass data to the page via props
  return { 
    props: { baseVehicle }
  }
}
